<template>
  <app-layout>
    <template v-slot:page>
      <router-view />
    </template>
  </app-layout>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import WmsLayout from "@/views/wms/layouts/WmsLayout.vue";

@Options({
  components: {
    'app-layout': WmsLayout
  }
})

export default class Index extends Vue {
  data() {
    return {}
  }
}
</script>
